class AddBeneficiary {
    id;
    name;
    curp;
    relationship;
    percentage;
    isVerified;
    investor;
    createdAt;
    updatedAt;
    contactData;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.curp = data.curp;
        this.relationship = data.relationship;
        this.percentage = data.percentage;
        this.isVerified = data.isVerified;
        this.investor = data.investor;
        this.createdAt = new Date(data.createdAt);
        this.updatedAt = new Date(data.updatedAt);
        this.contactData = data.contactData;
    }
}
export default AddBeneficiary;
